<div
  [ngClass]="{
    'on-screen': onScreen === true,
    'ticker-search-icon--active': hasSearchIcon
  }"
  class="ticker-search-wrapper"
>
  <div *ngIf="hasSearchIcon" class="ticker-search-icon">
    <va-icon
      size="small"
      name="search"
      class="fal fa-md"
      style="color: #979797"
    ></va-icon>
  </div>
  <div [ngClass]="{ 'on-screen-search': onScreen === true }">
    <nz-select
      id="searchbox"
      nzId="input-searchbox"
      nz-dropdown
      nzTrigger="click"
      [(nzVisible)]="isSearchMenuVisible"
      [nzDropdownMenu]="searchMenu"
      nzShowSearch
      nzServerSearch
      nzAllowClear
      [nzPlaceHolder]="placeholder"
      [(ngModel)]="selectedTicker"
      (ngModelChange)="onChangeTicker($event)"
      [nzDropdownRender]="onScreen === true ? renderTemplate : null"
      [nzDropdownClassName]="
        onScreen
          ? ['on-screen-ticker', 'ticker-search-dropdown']
          : 'ticker-search-dropdown'
      "
      [nzShowArrow]="true"
      [nzNotFoundContent]="noContentTemplate"
      (nzOnSearch)="searchTicker($event)"
      [nzDisabled]="disabled"
      [nzDropdownMatchSelectWidth]="false"
    >
      <ng-container
        *ngIf="
          onScreen === true && suggestedTickers && tickers;
          else searchBlock
        "
      >
        <nz-option-group
          [nzLabel]="
            !queryString
              ? suggestedTickers.length
                ? 'Suggestions:'
                : 'No Suggestions Found.'
              : searchResult.length
                ? 'Showing Results:'
                : 'No Results Found.'
          "
        >
          <!-- <ng-container *ngFor="let o of searchResult; index as i"> -->
          <nz-option
            nzCustomContent
            *ngFor="let r of !queryString ? suggestedTickers : searchResult"
            [nzLabel]="r.full_name + ' (' + r.ticker + ')'"
            [nzValue]="r"
            [nzDisabled]="tickers.length >= maxSelectedTickerCount"
            [ngClass]="{
              'select-footer-highlight':
                tickers.length >= maxSelectedTickerCount
            }"
          >
            <span
              [innerHtml]="
                r.full_name + ' (' + r.ticker + ')' | textHighlight: queryString
              "
            ></span>
          </nz-option>
          <!-- </ng-container> -->
        </nz-option-group>
      </ng-container>

      <ng-template #searchBlock>
        <nz-option
          nzCustomContent
          *ngFor="let r of searchResult"
          [nzLabel]="
            r.full_name + ' (' + isTickerTypeBg ? r.bTicker : r.ticker + ')'
          "
          [nzValue]="r"
        >
          <span
            [innerHtml]="
              isTickerTypeBg
                ? (r.full_name + ' (' + r.bTicker + ')'
                  | textHighlight: queryString)
                : (r.full_name + ' (' + r.ticker + ')'
                  | textHighlight: queryString)
            "
          ></span>
        </nz-option>
      </ng-template>

      <ng-template #noContentTemplate>
        <span
          class="no-content-item"
          *ngIf="
            isTickerSearchApiDataReady && queryString && !searchResult.length
          "
          >No Results Found.</span
        >
      </ng-template>
    </nz-select>
    <nz-dropdown-menu #searchMenu="nzDropdownMenu">
      <ng-container *ngIf="!queryString && isSearchMenuVisible">
        <app-comparative-ticker-search-menu
          [menuList]="menuList"
          [isSearchMenuVisible]="isSearchMenuVisible"
          [selectedOption]="selectedOption"
          [watchlistData]="watchlistData"
          [industryData]="industryData"
          [marketGeoData]="marketGeoData"
          [suggestedTickerData]="suggestedTickers"
          [recentlyVisitedTickers]="recentlyVisitedTickers"
          [isCreateNewModalIndustryMenu]="isCreateNewModalIndustryMenu"
          (handleApply)="handleApply($event)"
          (handleMenuChange)="handleMenuChange($event)"
        ></app-comparative-ticker-search-menu>
      </ng-container>
    </nz-dropdown-menu>
    <ng-template #renderTemplate>
      <div
        class="select-footer"
        [ngClass]="{
          'select-footer-highlight': tickers.length >= maxSelectedTickerCount
        }"
      >
        Selected Companies {{ tickers.length }}/{{ maxSelectedTickerCount }}
      </div>
    </ng-template>
  </div>
  <!-- <div>
      <button  class="button">Edit</button>
    </div>  -->
</div>
